import {
  forwardRef, useImperativeHandle, useMemo, useState,
} from 'react';
import PropTypes from 'prop-types';

// Utils
import Calendar from 'react-calendar';

// Components
import { Picto } from '../../atoms/Picto/Picto';

const CalendarInput = forwardRef(({
  startDate,
  endDate,
  handleChange,
  handleDayClick,
  isRange,
  showDoubleView,
  tileDisabled,
  minDate,
  maxDate,
  focusedDayDefault,
}, ref) => {
  const [focusedDay, setFocusedDay] = useState(focusedDayDefault || new Date());

  useImperativeHandle(ref, () => ({
    handleFocusDateChange(day) {
      setFocusedDay(day);
    },
  }));

  const handleFocusDayChange = ({ activeStartDate, action }) => {
    if (action === 'onChange') return;
    setFocusedDay(activeStartDate);
  };

  const value = useMemo(() => {
    if (isRange) {
      if (startDate || endDate) return [startDate, endDate];
      return [];
    }

    return startDate;
  }, [isRange, startDate, endDate]);

  return (
    <Calendar
      onChange={handleChange}
      onClickDay={handleDayClick}
      value={value}
      selectRange={isRange}
      showDoubleView={showDoubleView}
      className="calendar-input"
      locale="fr-FR"
      minDate={minDate}
      maxDate={maxDate}
      nextLabel={<Picto icon="chevronRight" width={28} height={28} />}
      prevLabel={<Picto icon="chevronLeft" width={28} height={28} />}
      activeStartDate={focusedDay}
      onActiveStartDateChange={handleFocusDayChange}
      tileDisabled={tileDisabled}
      minDetail="year"
      maxDetail="month"
    />
  );
});

CalendarInput.displayName = 'CalendarInput';

CalendarInput.propTypes = {
  startDate: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]),
  endDate: PropTypes.shape({}),
  handleChange: PropTypes.func,
  handleDayClick: PropTypes.func,
  isRange: PropTypes.bool,
  showDoubleView: PropTypes.bool,
  tileDisabled: PropTypes.func,
  minDate: PropTypes.shape({}),
  maxDate: PropTypes.shape({}),
  focusedDayDefault: PropTypes.date,
};

CalendarInput.defaultProps = {
  startDate: null,
  endDate: null,
  handleChange: () => {},
  handleDayClick: () => {},
  isRange: false,
  showDoubleView: false,
  tileDisabled: () => false,
  minDate: null,
  maxDate: null,
  focusedDayDefault: null,
};

export default CalendarInput;
